export default "__VITE_ASSET__gh5pXU7S__"